import {KTPlayerType} from '@src/types/kakaoTv';

// 상수는 구지 폴더까지 필요 없을듯..
// 이후 내용이 커진다면 constants/*.ts 형태로 사용

// -- api
export const TEMP = 'temp const';
// api --

// -- api
export const HTTP_CODE = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_MAINTENANCE: 503,
  UNKNOWN: 520,
  MAX_5XX: 599,
};

export const UNREGISTER_CODE = -2;

export const API_CODE = {
  ...HTTP_CODE,
  OK: 0,
  RUNTIME_EXCEPTION: -999,
};

// TODO: 이후 enum으로 변경! layer 테스트 중에서 상당히 많이 쓰이므로 Test 코드도 수정 필요!
export type LAYER_TYPE = 'ALERT' | 'CONFIRM' | 'LIST';

export const PHASE = {
  SANDBOX: 'sandbox',
  STAGING: 'staging',
  CBT: 'cbt',
  PRODUCTION: 'prod',
};

export const PROTOCOL_PREFIX = {
  ALPHA: 'alpha',
  KAKAO: 'kakao',
};

export const TALK_SCHEME = {
  SUBSCRIPTION_OPEN: 'kakaotalk://bizwebview/open',
  CHANNEL_HOME: 'kakaoplus://plusfriend/home',
  WEVIEW_CLOSE: 'kakaotalk://web/close',
  INAPPBROWSER_CLOSE: 'kakaotalk://inappbrowser/close',
};

export const STORE_URL = {
  ANDROID: 'https://play.google.com/store/apps/details?id=com.kakao.talk',
  IOS: 'https://itunes.apple.com/kr/app/id362057947',
};
export const NOTICE_URL = 'https://ss.kakao.com/pages/store/sweetbalance/notice';
export const HELP_URL = 'https://cs.kakao.com/helps?service=176&locale=ko';
export const INQUIRY_URL = 'https://cs.kakao.com/requests?service=176&locale=ko';
export const PRIVACY_POLICY_URL = 'https://www.kakao.com/policy/privacy?lang=ko';

export const KTPLAYER_SERVICE = 'kakao_subscription_on';
export const KTPLAYER_SECTION = 'planning_detail';
export const KTPLAYER_TYPE: {[key in KTPlayerType]: KTPlayerType} = {
  VOD: 'VOD',
  LIVE: 'LIVE',
};
